export default __webpack_public_path__ + "static/media/open sea.047ef5ed.png";